export default __webpack_public_path__ + "media/images/user/pencil-2e5405ac68a9505102997a39baf406dd.png";